import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';

import api from '~/services/api';
import { isNullOrEmpty } from '~/helpers/util';
import { CatchErrors } from '../common';

import {
  taskHistoryIndexRequest, taskHistoryIndexSuccess, taskHistoryIndexFailure, taskHistoryCreateSuccess,
  taskHistoryCreateFailure, taskHistoryReadSuccess, taskHistoryReadFailure, taskHistoryUpdateSuccess,
  taskHistoryUpdateFailure, taskHistoryDeleteSuccess, taskHistoryDeleteFailure
} from './actions';

export function* onIndex({ payload }) {
  try {
    let { projectId, taskId, filters } = payload;
    if (!filters) filters = [];

    let params = '';
    if (Array.isArray(filters)) {
      filters.map(e => {
        if (Object.keys(e).length === 1) {
          params += `${isNullOrEmpty(params) ? "?" : "&"}${Object.keys(e)[0].replace('_', '.')}=${e[Object.keys(e)[0]]}`;
        }
      });
    }

    const response = yield call(api.get, `projects/${projectId}/tasks/${taskId}/history${params}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskHistoryIndexSuccess(data, result.page, result.count));
  }
  catch (err) {
    yield put(taskHistoryIndexFailure());
  }
}

export function* onCreate({ payload }) {
  try {
    const response = yield call(
      api.post,
      `projects/${payload.data?.projectId}/tasks/${payload.data?.taskId}/history`,
      payload.data
    );

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskHistoryCreateSuccess(data));
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskHistoryCreateFailure());
  }
  finally {
    yield put(taskHistoryIndexRequest(payload.data?.projectId, payload.data?.taskId));
  }
}

export function* onRead({ payload }) {
  try {
    const { id } = payload;

    const response = yield call(api.get, `projects/${payload.data?.projectId}/taskHistory/${payload.data?.id}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskHistoryReadSuccess(data));
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskHistoryReadFailure());
  }
}

export function* onUpdate({ payload }) {
  try {
    const response = yield call(
      api.post,
      `projects/${payload.data?.projectId}/tasks/${payload.data?.taskId}/hours/${payload.data?.id}`,
      payload.data);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskHistoryUpdateSuccess(data));
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskHistoryUpdateFailure());
  }
  finally {
    yield put(taskHistoryIndexRequest(payload.data?.projectId));
  }
}

export function* onDelete({ payload }) {
  try {
    const { projectId, taskId, id } = payload;

    const response = yield call(api.delete, `projects/${projectId}/tasks/${taskId}/history/${id}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;

    const data = result.data;

    yield put(taskHistoryDeleteSuccess());
    yield put(taskHistoryIndexRequest(projectId, taskId));

    toast.success(result.message);
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskHistoryDeleteFailure());
  }
}

export default all([
  takeLatest('@taskHistory/INDEX_REQUEST', onIndex),
  takeLatest('@taskHistory/CREATE_REQUEST', onCreate),
  takeLatest('@taskHistory/READ_REQUEST', onRead),
  takeLatest('@taskHistory/UPDATE_REQUEST', onUpdate),
  takeLatest('@taskHistory/DELETE_REQUEST', onDelete),
]);